import { Button } from "@mui/material"
import React from "react"
import { GenericFormButtonType } from "./GenericForm"

/**
 * 
 * description
 * 
 * ###Import to use it
 *
 *```jsx
 *   import { ButtonSubmit } from './ButtonSubmit'
 *```
 *
 *### Usage
 *
 *```jsx
 * <ButtonSubmit 
 *   label={string} 
 *   isSubmit={boolean} 
 *   disabled={boolean}
 * />
 *```
 *
 *### Basic Example
 */

export const GenericFormReadOnlyWrapper = (props: GenericFormReadOnlyWrapper) => {
    return (
        <div className="generic-form-readonly">
            <Button 
                {...props.button}
                className={`btn-default btn-unblock-readonly ${props.button?.className}`}>
                { props.button?.label }
            </Button>

            {
                props.children
            }
        </div>
    )
}

type GenericFormReadOnlyWrapper = {
    children: React.ReactNode
    button?: GenericFormButtonType
}
